import React from 'react';
import TaxRegimeComparison from '../components/TaxRegimeComparison';

const TaxToolsPage: React.FC = () => {
  return (
    <div className="tax-tools-page-container">
      <h1>Tax Tools</h1>
      <p>Explore various tax-related tools to help with your financial planning.</p>
      <TaxRegimeComparison />
    </div>
  );
};

export default TaxToolsPage;
